/**
 * @file collapsible.tsx
 */

"use client";

import * as React from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

import { cn } from "visuais/fmt";

/**
 * @returns {JSX.Element} Componente colapsável.
 * @example
 * ```tsx
 * <Collapsible>
 *   <CollapsibleTrigger>Trigger</CollapsibleTrigger>
 *   <CollapsibleContent>Conteúdo</CollapsibleContent>
 * </Collapsible>
 * ```
 */
export function Collapsible({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

/**
 * @returns {JSX.Element} Gatilho do colapsável.
 * @example
 * ```tsx
 * <CollapsibleTrigger>Trigger</CollapsibleTrigger>
 * ```
 */
export function CollapsibleTrigger({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    />
  );
}

/**
 * @returns {JSX.Element} Conteúdo do colapsável.
 * @example
 * ```tsx
 * <CollapsibleContent>Conteúdo</CollapsibleContent>
 * ```
 */
export function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      {...props}
    />
  );
}
